import React, { Component } from "react";
import "./Skills.scss";

import SkillItem from "./SkillItem";
import SkillCards from "./skill-cards/SkillCards";

class Skills extends Component {
	constructor() {
		super();
		this.skills = [
			{
				skill: "HTML, CSS, SASS, JavaScript",
				value: 85,
			},
			{
				skill: "Angular, React, Django",
				value: 70,
			},
			{
				skill: "Android, Flutter",
				value: 80,
			},
			{
				skill: "iOS",
				value: 50,
			},
			{
				skill: "Git, Linux",
				value: 80,
			},
			{
				skill: "Data Base",
				value: 75,
			},
			{
				skill: "IoT",
				value: 50,
			},
			{
				skill: "AWS, Google Cloud, Firebase",
				value: 50,
			},
			{
				skill: "Play Store, App Store",
				value: 75,
			},
			{
				skill: "Scrum, Project Development",
				value: 90,
			},
			{
				skill: "Statistic Analysis",
				value: 75,
			},
			{
				skill: "English",
				value: 65,
			},
		];
	}

	render() {
		return (
			<React.Fragment>
				<div id="skills" className="skills col-12 col-sm-10 col-md-8 col-lg-6">
					<h3>Skills</h3>
					<div className="skills-container">
						<div className="skills-items">
							{this.skills
								.filter((e, i) => i % 2 === 0)
								.map((e, i) => {
									return <SkillItem key={i} value={e.value} skill={e.skill} />;
								})}
						</div>
						<div className="skills-items">
							{this.skills
								.filter((e, i) => i % 2 !== 0)
								.map((e, i) => {
									return <SkillItem key={i} value={e.value} skill={e.skill} />;
								})}
						</div>
					</div>
				</div>
				<SkillCards />
			</React.Fragment>
		);
	}
}

export default Skills;
